// Pure helpers for preview detection and experience-kind resolution used by the
// router. Kept side-effect free so they can be unit tested in isolation.

// Preview can arrive either as the `:preview` path segment
// (routerProps.preview === "preview") used by the home routes, or as a
// `?preview=true` query param used by the copilot/analytics preview URLs.
// Detect both so a preview of a switched-but-unpublished kind resolves the
// correct experience kind.
export function getIsPreview(
  previewSegment: string | undefined,
  search: string,
): boolean {
  const previewQueryParam = new URLSearchParams(search).get("preview");
  return previewSegment === "preview" || previewQueryParam === "true";
}

// When previewing an experience whose kind was switched in-place without
// publishing, the editor stores the draft kind in `previewMode` while the
// published `mode` is unchanged. For previews, resolve the experience kind
// (mode/theme) from `previewMode`, falling back to the published `mode`.
// Published (non-preview) requests keep using `mode` exactly as before.
export function getEffectiveMode({
  isPreview,
  mode,
  previewMode,
}: {
  isPreview: boolean;
  mode?: string;
  previewMode?: string;
}): string | undefined {
  return isPreview && previewMode ? previewMode : mode;
}
